module.exports = __webpack_public_path__ + "img/work2022revast.c84ac7a1.png";